export enum EmailFormMode {
  EditMode = 'edit',
  UnsubscribeMode = 'unsubscribe',
}
